import script from "./HomeModule.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeModule.vue?vue&type=script&setup=true&lang=js"

import "./HomeModule.vue?vue&type=style&index=0&id=8d62e312&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d62e312"]])

export default __exports__